module.exports = __webpack_public_path__ + "img/misc-mask-light.4750d898.png";